(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["david-home-comparison-live"]) return;
  try {
    
  function initDavidCompare(root) {
    if (!root || root.dataset.davidCompareReady === "true") return;

    const dialog = root.querySelector("[data-compare-dialog]");
    const openButtons = root.querySelectorAll("[data-compare-open]");
    const closeButtons = root.querySelectorAll("[data-compare-close]");

    if (!dialog || !openButtons.length) return;

    root.dataset.davidCompareReady = "true";

    const lock = (locked) => {
      document.documentElement.classList.toggle("david-compare-lock", locked);
    };

    const openDialog = () => {
      if (typeof dialog.showModal === "function" && !dialog.open) {
        dialog.showModal();
        lock(true);
      }
    };

    const closeDialog = () => {
      if (dialog.open) {
        dialog.close();
      }
      lock(false);
    };

    openButtons.forEach((button) => {
      button.addEventListener("click", openDialog);
    });

    closeButtons.forEach((button) => {
      button.addEventListener("click", closeDialog);
    });

    dialog.addEventListener("click", (event) => {
      if (event.target === dialog) {
        closeDialog();
      }
    });

    dialog.addEventListener("close", () => {
      lock(false);
    });

    dialog.addEventListener("cancel", () => {
      lock(false);
    });
  }

  function initAllDavidCompare(scope = document) {
    scope.querySelectorAll("[data-david-compare]").forEach(initDavidCompare);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAllDavidCompare());
  } else {
    initAllDavidCompare();
  }

  document.addEventListener("shopify:section:load", (event) => {
    if (event.target instanceof Element) {
      if (event.target.matches("[data-david-compare]")) {
        initDavidCompare(event.target);
      } else {
        initAllDavidCompare(event.target);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["david-home-lines"]) return;
  try {
    
  function initDavidLines(sectionRoot) {
    if (!sectionRoot || sectionRoot.dataset.davidLinesReady === "true") return;

    const toggle = sectionRoot.querySelector("[data-david-lines-toggle]");
    if (!toggle) return;

    sectionRoot.dataset.davidLinesReady = "true";

    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    const syncState = (playing) => {
      sectionRoot.dataset.playing = playing ? "true" : "false";
      toggle.dataset.playing = playing ? "true" : "false";
      toggle.setAttribute("aria-pressed", playing ? "false" : "true");
      toggle.setAttribute(
        "aria-label",
        playing ? toggle.dataset.labelPause || "Pause" : toggle.dataset.labelPlay || "Play"
      );
    };

    let playing = !reducedMotion.matches;
    syncState(playing);

    toggle.addEventListener("click", () => {
      playing = !playing;
      syncState(playing);
    });

    const handleReducedMotion = (event) => {
      if (event.matches) {
        playing = false;
      }
      syncState(playing);
    };

    if (typeof reducedMotion.addEventListener === "function") {
      reducedMotion.addEventListener("change", handleReducedMotion);
    } else if (typeof reducedMotion.addListener === "function") {
      reducedMotion.addListener(handleReducedMotion);
    }
  }

  function initAllDavidLines(scope = document) {
    scope.querySelectorAll("[data-david-lines]").forEach(initDavidLines);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAllDavidLines());
  } else {
    initAllDavidLines();
  }

  document.addEventListener("shopify:section:load", (event) => {
    if (event.target instanceof Element) {
      if (event.target.matches("[data-david-lines]")) {
        initDavidLines(event.target);
      } else {
        initAllDavidLines(event.target);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["david-home-module-08"]) return;
  try {
    
  function initDavidModule08(sectionRoot) {
    if (!sectionRoot || sectionRoot.dataset.davidModule08Ready === "true") return;

    const toggle = sectionRoot.querySelector("[data-david-module-08-toggle]");
    if (!toggle) return;

    sectionRoot.dataset.davidModule08Ready = "true";

    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    const syncState = (playing) => {
      sectionRoot.dataset.playing = playing ? "true" : "false";
      toggle.dataset.playing = playing ? "true" : "false";
      toggle.setAttribute("aria-pressed", playing ? "false" : "true");
      toggle.setAttribute(
        "aria-label",
        playing ? toggle.dataset.labelPause || "Pause" : toggle.dataset.labelPlay || "Play"
      );
    };

    let playing = !reducedMotion.matches;
    syncState(playing);

    toggle.addEventListener("click", () => {
      playing = !playing;
      syncState(playing);
    });

    const handleReducedMotion = (event) => {
      if (event.matches) {
        playing = false;
      }
      syncState(playing);
    };

    if (typeof reducedMotion.addEventListener === "function") {
      reducedMotion.addEventListener("change", handleReducedMotion);
    } else if (typeof reducedMotion.addListener === "function") {
      reducedMotion.addListener(handleReducedMotion);
    }
  }

  function initAllDavidModule08(scope = document) {
    scope.querySelectorAll("[data-david-module-08]").forEach(initDavidModule08);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAllDavidModule08());
  } else {
    initAllDavidModule08();
  }

  document.addEventListener("shopify:section:load", (event) => {
    if (event.target instanceof Element) {
      if (event.target.matches("[data-david-module-08]")) {
        initDavidModule08(event.target);
      } else {
        initAllDavidModule08(event.target);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["david-home-module-09"]) return;
  try {
    
  function initDavidModule09(sectionRoot) {
    if (!sectionRoot || sectionRoot.dataset.davidModule09Ready === "true") return;

    const viewport = sectionRoot.querySelector("[data-module-09-viewport]");
    const track = sectionRoot.querySelector("[data-module-09-track]");
    const prevButton = sectionRoot.querySelector("[data-module-09-prev]");
    const nextButton = sectionRoot.querySelector("[data-module-09-next]");

    if (!viewport || !track || !prevButton || !nextButton) return;

    sectionRoot.dataset.davidModule09Ready = "true";

    const randomize = sectionRoot.dataset.randomize === "true";
    const autoplayMs = Number(sectionRoot.dataset.autoplayMs || 3200);
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const getTrackPadding = () => {
      return Number.parseFloat(window.getComputedStyle(track).paddingLeft || "0") || 0;
    };

    if (randomize) {
      const shuffledSlides = Array.from(track.querySelectorAll("[data-module-09-slide]"));
      for (let index = shuffledSlides.length - 1; index > 0; index -= 1) {
        const swapIndex = Math.floor(Math.random() * (index + 1));
        [shuffledSlides[index], shuffledSlides[swapIndex]] = [shuffledSlides[swapIndex], shuffledSlides[index]];
      }
      shuffledSlides.forEach((slide) => track.appendChild(slide));
    }

    let slides = Array.from(track.querySelectorAll("[data-module-09-slide]"));
    let currentIndex = 0;
    let autoplayTimer = null;
    let paused = false;

    const goTo = (index) => {
      if (!slides.length) return;

      if (index < 0) {
        currentIndex = slides.length - 1;
      } else if (index >= slides.length) {
        currentIndex = 0;
      } else {
        currentIndex = index;
      }

      const target = slides[currentIndex];
      const padding = getTrackPadding();
      viewport.scrollTo({
        left: Math.max(0, target.offsetLeft - padding),
        behavior: prefersReducedMotion ? "auto" : "smooth"
      });
    };

    const startAutoplay = () => {
      if (autoplayMs <= 0 || slides.length < 2 || paused || prefersReducedMotion) return;
      stopAutoplay();
      autoplayTimer = window.setInterval(() => {
        goTo(currentIndex + 1);
      }, autoplayMs);
    };

    const stopAutoplay = () => {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    };

    prevButton.addEventListener("click", () => {
      goTo(currentIndex - 1);
      startAutoplay();
    });

    nextButton.addEventListener("click", () => {
      goTo(currentIndex + 1);
      startAutoplay();
    });

    viewport.addEventListener("mouseenter", () => {
      paused = true;
      stopAutoplay();
    });

    viewport.addEventListener("mouseleave", () => {
      paused = false;
      startAutoplay();
    });

    viewport.addEventListener("focusin", () => {
      paused = true;
      stopAutoplay();
    });

    viewport.addEventListener("focusout", () => {
      paused = false;
      startAutoplay();
    });

    viewport.addEventListener(
      "scroll",
      () => {
        const padding = getTrackPadding();
        let closestIndex = currentIndex;
        let closestDistance = Number.POSITIVE_INFINITY;

        slides.forEach((slide, index) => {
          const distance = Math.abs(slide.offsetLeft - viewport.scrollLeft - padding);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        currentIndex = closestIndex;
      },
      { passive: true }
    );

    window.addEventListener("resize", () => {
      goTo(currentIndex);
    });

    startAutoplay();
    goTo(0);
  }

  function initAllDavidModule09(scope = document) {
    scope.querySelectorAll("[data-david-module-09]").forEach(initDavidModule09);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAllDavidModule09());
  } else {
    initAllDavidModule09();
  }

  document.addEventListener("shopify:section:load", (event) => {
    if (event.target instanceof Element) {
      if (event.target.matches("[data-david-module-09]")) {
        initDavidModule09(event.target);
      } else {
        initAllDavidModule09(event.target);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["david-home-module-10"] && !Shopify.designMode) return;
  try {
    
  function initDavidModule10(sectionRoot) {
    if (!(sectionRoot instanceof Element)) return;
    if (sectionRoot.dataset.davidModule10Ready === "true") return;

    const viewport = sectionRoot.querySelector("[data-module-10-viewport]");
    const track = sectionRoot.querySelector("[data-module-10-track]");
    const prevButton = sectionRoot.querySelector("[data-module-10-prev]");
    const nextButton = sectionRoot.querySelector("[data-module-10-next]");

    if (!viewport || !track) return;

    const sourceSlides = Array.from(track.querySelectorAll("[data-module-10-slide]"));
    if (sourceSlides.length < 2) {
      sectionRoot.dataset.davidModule10Ready = "true";
      return;
    }

    sectionRoot.dataset.davidModule10Ready = "true";

    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const autoplayMs = Number(sectionRoot.dataset.autoplayMs || 4200);
    const cloneCount = Math.min(sourceSlides.length, window.innerWidth < 990 ? 1 : 2);

    const cloneSlide = (slide) => {
      const clone = slide.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      clone.removeAttribute("data-shopify-editor-block");
      return clone;
    };

    const prependFragment = document.createDocumentFragment();
    sourceSlides.slice(-cloneCount).forEach((slide) => prependFragment.appendChild(cloneSlide(slide)));

    const appendFragment = document.createDocumentFragment();
    sourceSlides.slice(0, cloneCount).forEach((slide) => appendFragment.appendChild(cloneSlide(slide)));

    track.prepend(prependFragment);
    track.append(appendFragment);

    const slides = Array.from(track.querySelectorAll("[data-module-10-slide]"));
    const originalStart = cloneCount;
    const originalCount = sourceSlides.length;
    const originalEnd = originalStart + originalCount - 1;
    const getTrackPadding = () => Number.parseFloat(window.getComputedStyle(track).paddingLeft || "0") || 0;

    let currentIndex = originalStart;
    let autoplayTimer = null;
    let normalizeTimer = null;
    let paused = false;

    const scrollToIndex = (index, behavior = "smooth") => {
      const target = slides[index];
      if (!target) return;
      currentIndex = index;
      viewport.scrollTo({
        left: Math.max(0, target.offsetLeft - getTrackPadding()),
        behavior
      });
    };

    const normalizePosition = () => {
      if (currentIndex < originalStart) {
        scrollToIndex(currentIndex + originalCount, "auto");
      } else if (currentIndex > originalEnd) {
        scrollToIndex(currentIndex - originalCount, "auto");
      }
    };

    const queueNormalize = () => {
      window.clearTimeout(normalizeTimer);
      normalizeTimer = window.setTimeout(normalizePosition, prefersReducedMotion ? 0 : 460);
    };

    const goTo = (delta) => {
      scrollToIndex(currentIndex + delta, prefersReducedMotion ? "auto" : "smooth");
      queueNormalize();
    };

    const stopAutoplay = () => {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    };

    const startAutoplay = () => {
      if (paused || prefersReducedMotion || autoplayMs <= 0) return;
      stopAutoplay();
      autoplayTimer = window.setInterval(() => {
        goTo(1);
      }, autoplayMs);
    };

    const syncCurrentIndex = () => {
      const padding = getTrackPadding();
      let closestIndex = currentIndex;
      let closestDistance = Number.POSITIVE_INFINITY;

      slides.forEach((slide, index) => {
        const distance = Math.abs(slide.offsetLeft - viewport.scrollLeft - padding);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      currentIndex = closestIndex;
    };

    prevButton?.addEventListener("click", () => {
      goTo(-1);
      startAutoplay();
    });

    nextButton?.addEventListener("click", () => {
      goTo(1);
      startAutoplay();
    });

    viewport.addEventListener(
      "scroll",
      () => {
        syncCurrentIndex();
        queueNormalize();
      },
      { passive: true }
    );

    const pause = () => {
      paused = true;
      stopAutoplay();
    };

    const resume = () => {
      paused = false;
      startAutoplay();
    };

    viewport.addEventListener("mouseenter", pause);
    viewport.addEventListener("mouseleave", resume);
    viewport.addEventListener("focusin", pause);
    viewport.addEventListener("focusout", resume);
    viewport.addEventListener("touchstart", pause, { passive: true });
    viewport.addEventListener("touchend", resume, { passive: true });

    window.addEventListener("resize", () => {
      syncCurrentIndex();
      normalizePosition();
    });

    scrollToIndex(originalStart, "auto");
    startAutoplay();
  }

  function initAllDavidModule10(scope = document) {
    scope.querySelectorAll("[data-david-module-10]").forEach(initDavidModule10);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAllDavidModule10());
  } else {
    initAllDavidModule10();
  }

  document.addEventListener("shopify:section:load", (event) => {
    if (event.target instanceof Element) {
      if (event.target.matches("[data-david-module-10]")) {
        initDavidModule10(event.target);
      } else {
        initAllDavidModule10(event.target);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["david-home-science-live"]) return;
  try {
    
  function initDavidScience(root) {
    if (!root || root.dataset.davidScienceReady === "true") return;

    const buttons = Array.from(root.querySelectorAll("[data-science-tab]"));
    const panels = Array.from(root.querySelectorAll("[data-science-panel]"));
    const mediaPanes = Array.from(root.querySelectorAll("[data-science-media]"));

    if (!buttons.length || !panels.length || !mediaPanes.length) return;

    root.dataset.davidScienceReady = "true";

    const setActive = (tabId) => {
      root.dataset.activeTab = tabId;

      buttons.forEach((button) => {
        const active = button.dataset.scienceTab === tabId;
        button.classList.toggle("is-active", active);
        button.setAttribute("aria-selected", active ? "true" : "false");
      });

      panels.forEach((panel) => {
        const active = panel.dataset.sciencePanel === tabId;
        panel.classList.toggle("is-active", active);
        panel.hidden = !active;
      });

      mediaPanes.forEach((mediaPane) => {
        const active = mediaPane.dataset.scienceMedia === tabId;
        mediaPane.classList.toggle("is-active", active);
      });
    };

    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        setActive(button.dataset.scienceTab || "bars");
      });
    });

    setActive(root.dataset.activeTab || "bars");
  }

  function initAllDavidScience(scope = document) {
    scope.querySelectorAll("[data-david-science]").forEach(initDavidScience);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAllDavidScience());
  } else {
    initAllDavidScience();
  }

  document.addEventListener("shopify:section:load", (event) => {
    if (event.target instanceof Element) {
      if (event.target.matches("[data-david-science]")) {
        initDavidScience(event.target);
      } else {
        initAllDavidScience(event.target);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["david-home-split-cta"]) return;
  try {
    
  function initDavidSplitCta(sectionRoot) {
    if (!sectionRoot || sectionRoot.dataset.davidSplitCtaReady === "true") return;

    const viewport = sectionRoot.querySelector("[data-split-cta-viewport]");
    const track = sectionRoot.querySelector("[data-split-cta-track]");
    const prevButton = sectionRoot.querySelector("[data-split-cta-prev]");
    const nextButton = sectionRoot.querySelector("[data-split-cta-next]");

    if (!viewport || !track || !prevButton || !nextButton) return;

    sectionRoot.dataset.davidSplitCtaReady = "true";

    const slides = Array.from(track.querySelectorAll("[data-split-cta-card]"));
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let currentIndex = 0;

    const getTrackPadding = () => {
      return Number.parseFloat(window.getComputedStyle(track).paddingLeft || "0") || 0;
    };

    const clampIndex = (index) => {
      if (!slides.length) return 0;
      return Math.max(0, Math.min(slides.length - 1, index));
    };

    const updateButtons = () => {
      prevButton.disabled = currentIndex <= 0;
      nextButton.disabled = currentIndex >= slides.length - 1;
    };

    const syncIndexFromScroll = () => {
      const padding = getTrackPadding();
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      slides.forEach((slide, index) => {
        const distance = Math.abs(slide.offsetLeft - viewport.scrollLeft - padding);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      currentIndex = clampIndex(closestIndex);
      updateButtons();
    };

    const goTo = (index) => {
      currentIndex = clampIndex(index);
      const target = slides[currentIndex];
      const padding = getTrackPadding();

      if (!target) return;

      viewport.scrollTo({
        left: Math.max(0, target.offsetLeft - padding),
        behavior: prefersReducedMotion ? "auto" : "smooth"
      });

      updateButtons();
    };

    prevButton.addEventListener("click", () => {
      goTo(currentIndex - 1);
    });

    nextButton.addEventListener("click", () => {
      goTo(currentIndex + 1);
    });

    viewport.addEventListener(
      "scroll",
      () => {
        window.requestAnimationFrame(syncIndexFromScroll);
      },
      { passive: true }
    );

    window.addEventListener("resize", syncIndexFromScroll);

    syncIndexFromScroll();
  }

  function initAllDavidSplitCta(scope = document) {
    scope.querySelectorAll("[data-david-split-cta]").forEach(initDavidSplitCta);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAllDavidSplitCta());
  } else {
    initAllDavidSplitCta();
  }

  document.addEventListener("shopify:section:load", (event) => {
    if (!(event.target instanceof Element)) return;

    if (event.target.matches("[data-david-split-cta]")) {
      initDavidSplitCta(event.target);
    } else {
      initAllDavidSplitCta(event.target);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["david-store-locator-widget"]) return;
  try {
    
  function initDavidStoreLocatorWidget(root) {
    if (!root || root.dataset.davidStoreLocatorReady === 'true') return;

    root.dataset.davidStoreLocatorReady = 'true';

    const target = root.querySelector('#pear-map-target');
    const overlay = root.querySelector('[data-david-store-locator-overlay]');
    const status = root.querySelector('[data-david-store-locator-status]');
    const vendorId = root.dataset.vendorId;
    const widgetName = root.dataset.widgetName || 'product-locator';
    const errorLabel = root.dataset.errorLabel || 'Store availability is currently unavailable.';

    if (!target || !overlay || !status || !vendorId) return;

    const hideOverlay = () => {
      overlay.classList.add('is-hidden');
      root.setAttribute('aria-busy', 'false');
    };

    const showFallback = (message) => {
      overlay.dataset.state = 'error';
      status.textContent = message;
      root.setAttribute('aria-busy', 'false');
    };

    const hasRenderedContent = () => {
      return target.childElementCount > 0 || target.textContent.trim().length > 0;
    };

    const observer = new MutationObserver(() => {
      if (hasRenderedContent()) {
        observer.disconnect();
        hideOverlay();
      }
    });

    observer.observe(target, {
      childList: true,
      subtree: true,
      characterData: true
    });

    window.setTimeout(() => {
      if (!hasRenderedContent()) {
        showFallback(errorLabel);
      }
    }, 3500);

    const config = {
      vendorId,
      widget: widgetName
    };

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://offers.pearcommerce.com/js/sdk.js?config=' + encodeURIComponent(JSON.stringify(config)) + '&_=' + Date.now();
    script.addEventListener('error', () => {
      showFallback(errorLabel);
    });
    document.head.appendChild(script);
  }

  function initAllDavidStoreLocatorWidgets(scope = document) {
    scope.querySelectorAll('[data-david-store-locator-root]').forEach(initDavidStoreLocatorWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllDavidStoreLocatorWidgets());
  } else {
    initAllDavidStoreLocatorWidgets();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (!(event.target instanceof Element)) return;

    if (event.target.matches('[data-david-store-locator-root]')) {
      initDavidStoreLocatorWidget(event.target);
    } else {
      initAllDavidStoreLocatorWidgets(event.target);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
